import { apiRoutes } from "../../config";
import { api } from "../../utils/lib/api";

const resolveApiErrorMessage = (error, fallback) => {
    const data = error?.response?.data;
    if (!data) return error?.message || fallback;
    if (typeof data === 'string') return data;
    if (typeof data.message === 'string') return data.message;
    if (typeof data.data?.error === 'string') return data.data.error;
    if (data.data) return JSON.stringify(data.data);
    return fallback;
};

export const uploadProducts = async ({
    enterpriseId,
    productIds,
    productAction
}) => {
    try {
        return (await api.post(
            apiRoutes.cashea.sendProducts,
            {
              enterpriseId,
              productIds,
              productAction
            }
        )).data;
    } catch (error) {
        let errorMessage = "Ocurrió un error al intentar ejecutar uploadProducts";
        if (error?.response?.data) errorMessage = error?.response?.data;
    
        throw new Error(errorMessage);
    }
}

export const bulkUpdateProducts = async ({
    brandName,
    categoryId,
    enterpriseId,
    productAction,
    merchantName,
    allMerchants
}) => {
    if(allMerchants) merchantName = undefined
    try {
        return (await api.post(
            apiRoutes.cashea.sendProducts,
            {
                brandName,
                categoryId,
                enterpriseId,
                productAction,
                merchantName,
                allMerchants
            }
        )).data;
    } catch (error) {
        let errorMessage = "Ocurrió un error al intentar ejecutar bulkUpdateProducts";
        if (error?.response?.data) errorMessage = error?.response?.data;
    
        throw new Error(errorMessage);
    }
}
export const fetchMerchantsAvailable = async (enterpriseId) => {
    try {
        return (await api.get(
            `${apiRoutes.cashea.merchantsNames}/${enterpriseId}`)).data;
    } catch (error) {
        let errorMessage = "Ocurrió un error al intentar operar MerchantsNames";
        if (error?.response?.data) errorMessage = error?.response?.data;
    
        throw new Error(errorMessage);
    }
}

export const getMerchantKey = async ({name, enterpriseId}) => {
    try {
        if(enterpriseId){
            return (await api.get(`${apiRoutes.cashea.merchantsNames}/${enterpriseId}`, {
                params: {
                    name,
                    enterpriseId
                }
            }));
        }
    } catch (error) {
        let errorMessage = "Ocurrió un error al intentar ejecutar getTrackingInfo";
        if (error?.response?.data) errorMessage = error?.response?.data;
    
        throw new Error(errorMessage);
    }
};

export const fetchCasheaMerchants = async ({ enterpriseId }) => {
    const response = await getMerchantKey({ name: 'all', enterpriseId });
    const payload = response?.data?.data;
    if (!payload) return [];
    if (Array.isArray(payload)) return payload.filter((merchant) => merchant?.name);
    return Object.values(payload).filter((merchant) => merchant?.name);
};

export const fetchCasheaMerchantByName = async ({ enterpriseId, name }) => {
    if (!enterpriseId || !name) return null;
    const response = await getMerchantKey({ name, enterpriseId });
    const payload = response?.data?.data;
    if (!payload) return null;
    if (payload.name) return payload;
    const merchants = Object.values(payload).filter((merchant) => merchant?.name);
    return merchants.find((merchant) => merchant.name === name) || null;
};


export const addMerchantsName = async ({
    enterpriseId,
    name,
    apiKey,
    tarifa,
    storeId,
    merchantId,
    merchantGroupId,
    employeeRole,
    tokenRefresh,
    firebaseApiKey,
    firebaseRefreshToken,
    priceStockEnabled,
    ordersEnabled,
    uptTarifa
}) => {
    // Las URLs (Merchant Web + Firebase) ya no son campos del merchant: son config global por
    // empresa (config.cashea.urls) y se guardan vía saveCasheaPluginConfig.
    try {
        return (await api.post(
            apiRoutes.cashea.merchantsNames,
            {
                enterpriseId,
                name,
                apiKey,
                tarifa,
                storeId,
                merchantId,
                merchantGroupId,
                employeeRole,
                tokenRefresh,
                firebaseApiKey,
                firebaseRefreshToken,
                priceStockEnabled,
                ordersEnabled,
                uptTarifa
            }
        )).data;
    
    } catch (error) {
        let errorMessage = "Ocurrió un error al intentar operar MerchantsNames";
        if (error?.response?.data) errorMessage = error?.response?.data;
    
        throw new Error(errorMessage);
    }
}

export const refreshCasheaMerchantToken = async ({
    enterpriseId,
    name,
}) => {
    try {
        return (await api.post(
            apiRoutes.cashea.refreshMerchantToken,
            {
                enterpriseId,
                name,
            }
        )).data;
    } catch (error) {
        throw new Error(resolveApiErrorMessage(
            error,
            "Ocurrió un error al intentar actualizar el token de Cashea",
        ));
    }
}

export const syncMerchantsName = async (
    syncMerchant,
) => {
    try {
        return (await api.post(
            apiRoutes.cashea.syncMerchants,{
                ...syncMerchant
            })).data;
    
    } catch (error) {
        let errorMessage = "Ocurrió un error al intentar operar MerchantsNames";
        if (error?.response?.data) errorMessage = error?.response?.data;
        
        throw new Error(errorMessage);
    }
}

export const deleteMerchantsName = async ({name}) => {
    try {
        return (await api.delete(
            apiRoutes.cashea.merchantsNames+'/'+name
            
        ));
    
    } catch (error) {
        let errorMessage = "Ocurrió un error al intentar operar MerchantsNames";
        if (error?.response?.data) errorMessage = error?.response?.data;
    
        throw new Error(errorMessage);
    }
}

export const downloadCategory = async ({enterpriseId}) => {
    try {
        console.log(apiRoutes.cashea.getCategory)
        return (await api.post(apiRoutes.cashea.getCategory, {enterpriseId}).data);
    
    } catch (error) {
        let errorMessage = "Ocurrió un error al intentar operar MerchantsNames";
        if (error?.response?.data) errorMessage = error?.response?.data;
    
        throw new Error(errorMessage);
    }
}

export const getReport = async (ent, fileType) =>{
    try {
        return ((await api.get(`${apiRoutes.cashea.getReport}/${ent}/report/cashea/${fileType}`)).data)
    } catch (error) {
        let errorMessage = "Ocurrió un error al intentar ejecutar getReport";
        if (error?.response?.data) errorMessage = error?.response?.data;
    
        throw new Error(errorMessage);
    }
}

export const getCasheaPluginConfig = async (enterpriseId) => {
    try {
        const response = await api.get(`${apiRoutes.cashea.pluginConfig}/${enterpriseId}/cashea`);
        return response?.data?.data?.configData || {};
    } catch (error) {
        let errorMessage = "Ocurrió un error al intentar obtener la configuración del plugin de Cashea";
        if (error?.response?.data) errorMessage = error?.response?.data;
        throw new Error(errorMessage);
    }
};

export const getCasheaAccountConfig = async (enterpriseId) => {
    try {
        const response = await api.get(`${apiRoutes.cashea.account}/${enterpriseId}`);
        return response?.data?.data || {};
    } catch (error) {
        let errorMessage = "Ocurrió un error al intentar obtener la configuración de cuenta de Cashea";
        if (error?.response?.data) errorMessage = error?.response?.data;
        throw new Error(errorMessage);
    }
};

export const saveCasheaAccountConfig = async (enterpriseId, payload) => {
    try {
        const body = typeof payload === 'string'
            ? { urlBase: payload }
            : payload;
        return (await api.put(
            `${apiRoutes.cashea.account}/${enterpriseId}`,
            body
        )).data;
    } catch (error) {
        let errorMessage = "Ocurrió un error al intentar guardar la configuración de cuenta de Cashea";
        if (error?.response?.data) errorMessage = error?.response?.data;
        throw new Error(errorMessage);
    }
};

export const saveCasheaPluginConfig = async (enterpriseId, config) => {
    try {
        return (await api.put(
            `${apiRoutes.cashea.pluginConfig}/${enterpriseId}/cashea`,
            { config }
        )).data;
    } catch (error) {
        let errorMessage = "Ocurrió un error al intentar guardar la configuración del plugin de Cashea";
        if (error?.response?.data) errorMessage = error?.response?.data;
        throw new Error(errorMessage);
    }
};

export const testCasheaOrderEndpoint = async ({
    enterpriseId,
    merchantName,
    endpoint,
    merchantWebOrdersBaseUrl,
    orderDetailsBaseUrl,
    orderInstallmentsBaseUrl,
    orderUuid,
}) => {
    try {
        return (await api.post(
            `${apiRoutes.cashea.testOrderEndpoint}/${enterpriseId}/orders/test-endpoint`,
            {
                merchantName,
                endpoint,
                merchantWebOrdersBaseUrl,
                orderDetailsBaseUrl,
                orderInstallmentsBaseUrl,
                orderUuid,
            }
        )).data;
    } catch (error) {
        let errorMessage = "Ocurrió un error al intentar probar el endpoint de órdenes de Cashea";
        if (error?.response?.data) errorMessage = error?.response?.data;

        throw new Error(errorMessage);
    }
}